import React, { useState } from "react";
import HeaderMain from "./partials/HeaderMain";
import Content from "./partials/Content";
import MobileSideBar from './partials/SideBar/mobile'
import Footer from "./partials/Footer";
import { useLocation } from 'react-router-dom';
import TabsComponent from "./DashboardComponent/Tabs"

const Dashboard = () => {
  const [sidebarVisible, setSidebarVisible] = useState(true);
  const location = useLocation();
  const isRootPath = location.pathname === '/';

  return (
    <div className="flex flex-col h-auto">
      <HeaderMain   sidebarVisible={sidebarVisible} toggleSidebar={() => setSidebarVisible((prev) => !prev)}  />
        
      <MobileSideBar visible={sidebarVisible} />
      {isRootPath ? (
        <div>
          <TabsComponent sidebarVisible={sidebarVisible}/>
        </div>
      ) : (
        <div className="flex relative flex-1">
          <Content sidebarVisible={sidebarVisible} />
        </div>
      )}
   
      
    </div>
  );
};

export default Dashboard;
